import React, { useCallback, useEffect, useState } from 'react';
import { Spinner, Tables } from '../../../../../Components';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { showError } from '../../../../../Helper';
import { GetDeveloperCampaigns } from '../../../../../Services';
import { DeveloperCampaignsHeaderData } from './DeveloperCampaignsHeaderData';
import { TableActions } from '../../../../../Enums';
import { CampaignManangementDialog } from '../../../PropertiesView/PropertiesProfileManagementView/Sections/PropertiesProfileMarketingComponent/Sections/PropertyMarketingCampaigns/CampaignManangementDialog';
import { DeleteDialog } from '../../../CampaignView/DeleteDialog';
import { DateRangePickerComponent } from '../../../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent';

export const DeveloperCampaignsComponent = ({ parentTranslationPath, id }) => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoading, setIsLoading] = useState(false);
  const [campaignsData, setCampaignsData] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState({
    createDialog: false,
    deleteDialog: false,
  });

  const [filter, setFilter] = useState({
    developerContactId: id,
    pageIndex: 0,
    pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
    startDate: null,
    endDate: null,
  });

  const getDeveloperCampaigns = async () => {
    setIsLoading(true);
    try {
      const res = await GetDeveloperCampaigns(filter);
      setCampaignsData(res);
    } catch {
      showError('something-went-wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const onActionClicked = useCallback((actionEnum, item) => {
    if (actionEnum === TableActions.editText.key) {
      setActiveItem(item);
      setIsDialogOpen((prev) => ({ ...prev, createDialog: true }));
    } else if (actionEnum === TableActions.deleteText.key) {
      setActiveItem(item);
      setIsDialogOpen((prev) => ({ ...prev, deleteDialog: true }));
    }
  }, []);
  const onFilterValuesChanged = (e) => {
    if (e && !!Object.values(e).length) {
      const { value, searchableKey } = Object.values(e)[0];

      setFilter((filter) => {
        if (value === '' || value === null || value === undefined) {
          const { [searchableKey]: removed, ...rest } = filter;
          return rest;
        } else {
          return {
            ...filter,
            [searchableKey]: value,
          };
        }
      });
    }
  };
  const reloadData = () => {
    getDeveloperCampaigns();
  };
  useEffect(() => {
    getDeveloperCampaigns();
  }, [filter]);
  return (
    <div className='d-flex-v mt-3'>
      <Spinner isActive={isLoading} />
      <Button
        className='btns mx-3 mb-2 theme-solid'
        onClick={() =>
          setIsDialogOpen((prev) => ({ ...prev, createDialog: true }))
        }
      >
        <span className='mdi mdi-plus' />
        {t('add-new')}
      </Button>

      <div className='w-100 mt-3'>
        <div className='d-flex-v-center-h-end mb-3 mr-5'>
          <DateRangePickerComponent
            emptyLabel={'All'}
            onClearClicked={() =>
              setFilter((prev) => ({
                ...prev,
                startDate: null,
                endDate: null,
              }))
            }
            ranges={[
              {
                startDate: filter.startDate,
                endDate: filter.endDate,
                key: 'selection',
              },
            ]}
            onDateChanged={(selectedDate) => {
              setFilter((prev) => ({
                ...prev,
                startDate: selectedDate?.selection?.startDate || null,
                endDate: new Date(
                  moment(selectedDate?.selection?.endDate).endOf('day')
                ),
              }));
            }}
          />
        </div>
        <Tables
          data={campaignsData.result || []}
          headerData={DeveloperCampaignsHeaderData}
          actionsOptions={{ onActionClicked }}
          itemsPerPage={filter.pageSize}
          activePage={filter.pageIndex}
          totalItems={campaignsData.totalCount}
          defaultActions={[
            { enum: TableActions.editText.key },
            { enum: TableActions.deleteText.key },
          ]}
          onPageIndexChanged={(pageIndex) => {
            setFilter((prev) => ({ ...prev, pageIndex }));
          }}
          onPageSizeChanged={(pageSize) => {
            setFilter((prev) => ({ ...prev, pageSize, pageIndex: 0 }));
          }}
          parentTranslationPath={parentTranslationPath}
          isWithFilter
          filterData={DeveloperCampaignsHeaderData.map((item) => ({
            key: item.key,
            id: item.id,
            filterType: item.filterType,
            searchableKey: item.searchableKey ?? item.input,
            filterBy: item.filterBy,
          }))}
          FilterDisabledButton
          onFilterValuesChanged={onFilterValuesChanged}
        />
      </div>

      {isDialogOpen.createDialog && (
        <CampaignManangementDialog
          isDialogOpen={isDialogOpen}
          activeItem={activeItem}
          onSave={() => {
            reloadData();
            setIsDialogOpen((prev) => ({ ...prev, createDialog: false }));
            setActiveItem(null);
          }}
          onClose={() => {
            setActiveItem(null);
            setIsDialogOpen((prev) => ({ ...prev, createDialog: false }));
          }}
          parentTranslationPath={'PropertiesProfileManagementView'}
          developerId={id}
        />
      )}

      {isDialogOpen.deleteDialog && (
        <DeleteDialog
          activeItem={activeItem}
          setActiveItem={setActiveItem}
          isDeleteDialogOpen={isDialogOpen.deleteDialog}
          setIsDeleteDialogOpen={() =>
            setIsDialogOpen((prev) => ({ ...prev, deleteDialog: false }))
          }
          reloadData={reloadData}
          onCloseClicked={() => {
            setIsDialogOpen((prev) => ({ ...prev, deleteDialog: false }));
            setActiveItem(null);
          }}
          onCancelClicked={() => {
            setIsDialogOpen((prev) => ({ ...prev, deleteDialog: false }));
            setActiveItem(null);
          }}
          parentTranslationPath={'PropertiesProfileManagementView'}
        />
      )}
    </div>
  );
};
